import React, { FC, useState } from "react";
import styled from "styled-components";
import { Drawer } from "antd";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import { PrimaryButtonX } from "../Components/Button3D";
import {
  getCookies,
  removeCookie,
  removeUserData,
  removeUserId,
  setUserData,
  getUserData,
} from "../utils/utilsFunctions";
import { NavLink, useHistory } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { UPDATE_USER } from "../Apollo/graphql/Mutation/UserMutations";

const MobileMenuContainer = styled.div`
  /* background: green; */
`;

const MenuContainer = styled.ul`
  display: flex;
  list-style: none;
  flex-direction: column;
  align-items: center;
  padding: 0;
  padding-top: 1rem;
  margin: 0;
  width: 100%;
`;
const MenuItem = styled.li`
  display: flex;
  text-transform: uppercase;
  font-size: 16px;
  padding: 1rem;
  font-weight: bold;
  cursor: pointer;
`;
const MenuText = styled(NavLink)`
  color: #fff;
  &:hover {
    /* color: #1196DD;
    border-radius: 10px; */
  }
`;
const MyButton = styled(PrimaryButtonX)`
  border-radius: 20px;
  height: 3rem;
  font-size: 16px;
  width: 200px;

  @media screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
const DrawerX = styled(Drawer)`
  .ant-drawer-close {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    display: flex;
    padding: 20px;
    color: rgba(0, 0, 0, 0.45);
    color: white;
    font-weight: 700;
    font-size: 16px;
    font-style: normal;
    line-height: 1;
    text-align: center;
    text-transform: none;
    text-decoration: none;
    background: transparent;
    border: 0;
    outline: 0;
    cursor: pointer;
    transition: color 0.3s;
    text-rendering: auto;
  }
  .ant-drawer-body {
    /* padding: 0!important; */
  }
`;
const IconDiv = styled.div<MProps>`
  display: none;
  color: ${(props) => (props.color ? props.color : "#000")};

  @media screen and (max-width: 968px) {
    display: flex;
  }
`;
interface MProps {
  color?: string;
}
const MobileMenu: FC<MProps> = ({ color }) => {
  const history = useHistory();
  const [visible, setVisible] = useState(false);

  const [updateUserMutation] = useMutation(UPDATE_USER);
  const user = JSON.parse(getUserData("user"));
  const isSeller = user?.isSeller === true;
  const onClickSellerHandler = async () => {
      await updateUserMutation({
        variables: {
          userId: user?._id,
          input: {
            isSeller: true,
          },
        },
      })
        .then((data) => {
          setUserData(JSON.stringify(data.data.updateUser));
        })
        .catch((err) => console.log("Something went wrong!", err));

      history.push("/start-selling");
    };


  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };
  const handleLogout = () => {
    removeCookie();
    removeUserId();
    removeUserData();
    history.push("/");
  };
  const handleSignUp = () => {
    history.push("/register");
  };
  const handleSignIn = () => {
    history.push("/signin");
  };

  return (
    <MobileMenuContainer>
      <IconDiv onClick={showDrawer} color={color}>
        <MenuOutlined style={{ fontSize: "2rem" }} />
      </IconDiv>
      <DrawerX
        placement="right"
        onClose={onClose}
        visible={visible}
        closeIcon={<CloseOutlined style={{ fontSize: "1.5rem" }} />}
        bodyStyle={{ background: "#1A2635" }}
      >
        <MenuContainer>
          <MenuItem>
            <MenuText to="/" activeStyle={{ color: "#1196DD" }}>
              Home
            </MenuText>
          </MenuItem>
          <MenuItem>
            <MenuText to="/marketplace" activeStyle={{ color: "#1196DD" }}>
              Marketplace
            </MenuText>
          </MenuItem>
          <MenuItem>
            <MenuText to="/printers" activeStyle={{ color: "#1196DD" }}>
              Printers
            </MenuText>
          </MenuItem>
          <MenuItem>
            <MenuText to="/aboutus" activeStyle={{ color: "#1196DD" }}>
              FAQ
            </MenuText>
          </MenuItem>
          <MenuItem>
            <MenuText
              to="/why-use-3dprintit"
              activeStyle={{ color: "#1196DD" }}
            >
              Why use 3Dprintit?
            </MenuText>
          </MenuItem>
          {!!getCookies() && (
            <>
              <MenuItem>
                <MenuText
                  to="/dashboard/orders"
                  activeStyle={{ color: "#1196DD" }}
                >
                  Dashboard
                </MenuText>
              </MenuItem>
              <MenuItem>
                <MenuText
                  to="/dashboard/profile"
                  activeStyle={{ color: "#1196DD" }}
                >
                  Profile
                </MenuText>
              </MenuItem>
              <MenuItem>
                <MenuText
                  to="/dashboard/inbox"
                  activeStyle={{ color: "#1196DD" }}
                >
                  Inbox
                </MenuText>
              </MenuItem>
              {!isSeller && (
                <MenuItem>
                  <MyButton type="ghost" onClick={onClickSellerHandler}>
                    Become a Seller
                  </MyButton>
                </MenuItem>
              )}
            </>
          )}
          <MenuItem>
            {!!getCookies() ? (
              <MyButton type="primary" onClick={handleLogout}>
                Log Out
              </MyButton>
            ) : (
              <div>
                <MyButton type="primary" onClick={handleSignUp}>
                  Sign Up
                </MyButton>
                <MyButton
                  type="primary"
                  onClick={handleSignIn}
                  style={{ marginTop: "1.5rem" }}
                >
                  Sign In
                </MyButton>
              </div>
            )}
          </MenuItem>
        </MenuContainer>
      </DrawerX>
    </MobileMenuContainer>
  );
};

export default MobileMenu;
